module.exports = "/_next/static/images/initial-291d965b460403bf50712f32e45a6c6f.jpg";